import React, { useState } from 'react'
import './Home.css';
import { useNavigate } from 'react-router-dom';

import NavBar from "../Components/NavBar";
import logo from '../Assets/logo.png';

const leftCtx = require.context('../Assets/image-left', false, /\.(png|webp|jpg|jpeg|gif)$/i);
const leftImages = leftCtx.keys().map(leftCtx);

const rightCtx = require.context('../Assets/image-right', false, /\.(png|webp|jpg|jpeg|gif)$/i);
const rightImages = rightCtx.keys().map(rightCtx);

const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

const Home = () => {
  const navigate = useNavigate();
  const [leftImg] = useState(() => leftImages.length ? pickRandom(leftImages) : null);
  const [rightImg] = useState(() => rightImages.length ? pickRandom(rightImages) : null);

  return (
    <div className="filler-div">
      <div className="main-menu">
        {leftImg && <img src={leftImg} className="home-character home-character-left" alt="" onClick={() => navigate('/login')} />}
        {rightImg && <img src={rightImg} className="home-character home-character-right" alt="" />}
        <img src={logo} alt="FunGhoul's Lijsties" className='logo' />
        <NavBar />
      </div>
    </div>
  )
}

export default Home
